/**
 * Copyright 2024 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { useEffect } from 'react';
import useLatestCallback from 'use-latest-callback';
export const useResize = (ref, callback) => {
    const latestCallback = useLatestCallback(callback);
    useEffect(() => {
        // eslint-disable-next-line compat/compat
        const observer = new ResizeObserver(entries => {
            const entry = entries[0];
            const { height, width } = entry.contentRect;
            latestCallback({ height, width });
        });
        const element = ref.current;
        if (element) {
            observer.observe(element);
        }
        return () => {
            if (element && observer) {
                observer.unobserve(element);
                observer.disconnect();
            }
        };
    }, [latestCallback, ref]);
};
